module.exports = __webpack_public_path__ + "static/media/klima-10.2bac8bfc.jpg";